import type { ISerialize } from '@/objects/ISerialize';
import { BlockedBib } from './BlockedBib';
import { Category } from './Category';
import { Eventinfo } from './Eventinfo';
import { GroupWithCount } from './GroupWithCount';
import { BibAssignSort } from './BibAssignSort';

export class BibAssignSaveRequest implements ISerialize {
    public BlockedBibs: BlockedBib[];

    public Categories: Category[];

    public EventInfo: Eventinfo | null;

    public Groups: GroupWithCount[];

    public Sorts: BibAssignSort[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        BlockedBibs?: BlockedBib[];
        Categories?: Category[];
        EventInfo?: Eventinfo | null;
        Groups?: GroupWithCount[];
        Sorts?: BibAssignSort[];
    }) {
        this.BlockedBibs = values.BlockedBibs ?? [];

        this.Categories = values.Categories ?? [];

        this.EventInfo = values.EventInfo ?? null;

        this.Groups = values.Groups ?? [];

        this.Sorts = values.Sorts ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"BlockedBibs": [ ${this.BlockedBibs.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"Categories": [ ${this.Categories.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"EventInfo": ${!this.EventInfo ? null : this.EventInfo?.serialize()}` +
            ',' +
            `"Groups": [ ${this.Groups.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"Sorts": [ ${this.Sorts.map((x) => (!x ? null : x?.serialize()))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of BibAssignSaveRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        BlockedBibs?: BlockedBib[];
        Categories?: Category[];
        EventInfo?: Eventinfo | null;
        Groups?: GroupWithCount[];
        Sorts?: BibAssignSort[];
    }): BibAssignSaveRequest {
        return new BibAssignSaveRequest(values);
    }

    public static _FromServerJson(json: any): BibAssignSaveRequest {
        return new BibAssignSaveRequest({
            BlockedBibs: json.BlockedBibs?.map((x: any) => BlockedBib._FromServerJson(x)),
            Categories: json.Categories?.map((x: any) => Category._FromServerJson(x)),
            EventInfo: json.EventInfo ? Eventinfo._FromServerJson(json.EventInfo) : null,
            Groups: json.Groups?.map((x: any) => GroupWithCount._FromServerJson(x)),
            Sorts: json.Sorts?.map((x: any) => BibAssignSort._FromServerJson(x)),
        });
    }

    /**
     * Creates an instance of BibAssignSaveRequest from another instance of BibAssignSaveRequest.
     * @param other The BibAssignSaveRequest you want to clone
     * @returns A cloned BibAssignSaveRequest
     */
    public static FromOther(other: BibAssignSaveRequest): BibAssignSaveRequest {
        return BibAssignSaveRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return BibAssignSaveRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'BibAssignSaveRequest';
}
